"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmissionConsumption = exports.removeGlobalFootnoteReference = void 0;
const InputType_1 = require("./InputType");
const removeGlobalFootnoteReference = (vueFormatterData) => {
    return vueFormatterData.replace(/<sup>{(?:{)?ft_nemo-fn_eec-global-disclaimer}(?:})?<\/sup>/g, '');
};
exports.removeGlobalFootnoteReference = removeGlobalFootnoteReference;
const getEmissionConsumption = (vueFormatterService, localeService, authorInputValue) => __awaiter(void 0, void 0, void 0, function* () {
    const { language, countryCode } = localeService;
    const inputType = (0, InputType_1.getInputType)(authorInputValue);
    let vueData;
    if (inputType === 'carline') {
        vueData = yield vueFormatterService.vueRangeForCarline(countryCode, language, authorInputValue);
    }
    else if (inputType === 'audicode') {
        vueData = yield vueFormatterService.vueForAudiCode(countryCode, language, authorInputValue);
    }
    if (vueData) {
        const { formattedConsumption, formattedEmission } = vueData;
        const formattedCo2Class = vueData === null || vueData === void 0 ? void 0 : vueData.formattedCo2Class;
        const dischargedConsumption = vueData === null || vueData === void 0 ? void 0 : vueData.formattedDischargedConsumption;
        const dischargedCO2Class = vueData === null || vueData === void 0 ? void 0 : vueData.formattedDischargedCo2Class;
        return (0, exports.removeGlobalFootnoteReference)(`${formattedConsumption}${formattedEmission !== undefined ? `; ${formattedEmission}` : ''}${formattedCo2Class !== undefined ? `; ${formattedCo2Class}` : ''}${dischargedConsumption !== undefined ? `; ${dischargedConsumption}` : ''}${dischargedCO2Class !== undefined ? `; ${dischargedCO2Class}` : ''}`);
    }
    console.warn('dynamic-footnote-service no carline or configuration found in author input.');
});
exports.getEmissionConsumption = getEmissionConsumption;
//# sourceMappingURL=EmissionConsumption.js.map